import { NAT_NUM_1000_9000 } from "../../../../SubjectData/BasicWords/Numbers/NatNums.js";
import "../../../Deck.css";
import FlashcardInterface from "../../../Flashcard_Interface.js";
import HeaderNav from "../../../../Components/Header/Header_Nav/Header_Nav.js";

export default function NAT_NUM_1000_9000_DECK() {
  return (
    <>
      <HeaderNav GoBack_to="/NumbersNav" />
      <FlashcardInterface deckData={NAT_NUM_1000_9000} title="Native Numbers: 1000-9000" />
    </>
  );
}
